<template>
  <div class="goodListBox">
    <div class="goodListHead">
      <div class="headLeft" @click="$router.go(-1)" >
        <img src="../../assets/img/icon/Arrowleft000.png" alt />
      </div>
      <div class="centerSearch">
		  <form action="/">
			<van-search v-model="value" shape="round" @search="onSearch" placeholder="搜索商品" />
		</form>
      </div>
      <div class="headRight" @click="togglePermu">
        <img v-if=" permutation == 'rect' " src="../../assets/img/icon/rectShow.png" alt />
        <img v-if=" permutation ==  'vertical' " src="../../assets/img/icon/verticalShow.png" alt />
      </div>
    </div>
    <div class="listTools">
      <div  @click="sortList(1)">
        <span>综合</span>
      </div>
      <div @click="sortList(2)">
        <span>销量</span>
      </div>
      <div>
        <span @click="sortList(3)" >价格</span>
        <img :src="horl ? himg : limg" alt />
      </div>
      <div @click="showFilters()" >
        <span>筛选</span>
        <img src="../../assets/img/icon/filters.png" alt />
      </div>
    </div>
	<div class="goodslistbox" >
		<van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="5"
          :immediate-check="false"
          @load="onLoad()"
        >
		<div v-if=" permutation == 'vertical' ">
		  <listOfItems :data='goosList'   @goCommodityDetails='goCommodityDetails' >
			  <img v-if="israffle == 1" src="../../assets/img/icon/dayLottery.png" alt="">
		  </listOfItems>
		</div>
		<div v-if=" permutation == 'rect' ">
		  <verticalItemList :data='goosList'  >
			  <img v-if="israffle == 1" src="../../assets/img/icon/dayLottery.png" alt="">
		  </verticalItemList>
		</div>
		</van-list>
	</div>
	<van-action-sheet v-model="showFilter">
		<div class="filterContent">
			<div class="topIcon"></div>
			<div class="priceRange">
				<h4>价格区间</h4>
					<van-field v-model="lowPrice" name="最低价" placeholder="最低价" />
					<span>-</span>
					<van-field v-model="highPrice" name="最高价" placeholder="最高价" />
			</div>
			<div class="brand">
				<h4>品牌</h4>
				<div class="brandList">
					<span :class="objindex == item.brand_id?'active':''" v-for="(item,index) in sxpp" :key="index" @click="xzpp(item)">{{item.name}}</span>
				</div>
			</div>
			<div class="dayLuckDraw">
				<h4>天天抽奖</h4>
				<div class="LuckDraw" @click="sfsxcj()" >
					<span :class="sxcj ? 'active':''">抽奖</span>
				</div>
			</div>
			<div class="filterBtn" >
				<button class="resetBtn" @click="chongzhi()" >重置</button>
				<button class="saveBtn" @click="qieren()">确定</button>
			</div>
		</div>
	</van-action-sheet>
  </div>
</template>

<script>
import listOfItems from "../../components/listOfItems.vue";
import verticalItemList from "../../components/verticalItemList.vue";
export default {
  name: "goodsList",
  data() {
    return {
	  value: "",
      permutation: "vertical",
	  goosList:[],
	   page_no:1,
     page_size:10,
	 shopId:this.$route.query.shop_id,
	 categoryId:this.$route.query.category_id,
	 israffle:this.$route.query.is_raffle,

	loading: true,
      finished: false,
	 showFilter: false,
      lowPrice:"",
      highPrice:"",
      sortActivity:0,
      sxpp:[],
      objindex:'',
      sortType:'',
      sxcj:false,
	  horl:true,
	  toggleBuynum:true,
	  sortString:'',
      himg:require('../../assets/img/icon/higher.png'),
      limg:require('../../assets/img/icon/low.png')
    };
  },
  components: {
    listOfItems,
    verticalItemList
  },
   created(){
	if(this.israffle == 1){
			this.getRaffle();
		}else{
			this.getList();
		}
	localStorage.removeItem('isCart') ;
	
	//获取筛选品牌
	this.getsxData();
  },
  methods: {
	  onLoad(){
        this.page_no = this.page_no + 1;
		if(this.israffle == 1){
			this.getRaffle();
		}else{
			this.getList();
		}
	},
	sfsxcj(){
	  this.sxcj = !this.sxcj;
	  if(this.sxcj == true){
		  this.israffle = 1;
	  }
	},
	chongzhi(){
       this.objindex = ''
    },
	//点击筛选确认
	qieren(){
		debugger
	  this.page_no = 1;
      this.sortActivity = 3;
      this.goosList = [];
	  this.showFilter = false;
	  if(this.israffle == 1){
			this.getRaffle();
		}else{
			this.getList();
		}
	},
	xzpp(obj){
      if(this.objindex==obj.brand_id){
        this.objindex = '';
      }else{
        this.objindex = obj.brand_id;
      }
	},
	 sortList(type){
		 this.goosList = [];
	 	 this.page_no = 1;
	    this.loading = true;
     	 this.finished = false;
		  if(type == 1){
			this.sortString = ""
		  }else if(type == 2){
			this.toggleBuynum = !this.toggleBuynum;
			if(this.toggleBuynum){
				console.log(this.toggleBuynum)
         		this.sortString = "buynum_asc"
			}else{
				console.log(this.toggleBuynum)
				this.sortString = 'buynum_desc'
			}
		  }else if(type == 3){
			  this.horl = !this.horl;
			  if(this.horl){
         		this.sortString = 'price_asc'
			}else{
				this.sortString = 'price_desc'
			}
		  }
		  if(this.israffle == 1){
			this.getRaffle();
		}else{
			this.getList();
		}
	 },
	  getList(val) {
		  console.log(this.shopId);
		  let param ={
			  page_no:this.page_no,
			  page_size:this.page_size,
			  seller_id:this.shopId,
			  category:this.categoryId,
			  sort:this.sortString,
			  keyword:val,
			  isRakeBack:this.$route.query.is_RakeBack,
			  brand:this.objindex,
			  priceSmall:this.lowPrice,
			  priceBig:this.highPrice,
			  goodType:this.$route.query.goodType
		  }
      this.getRequest(`goods/search/searchGoods`, param).then(res => {
		  console.log(res.data.data)
        if(res.data.code == 1){
		  this.goosList = [];
		   this.loading = false;
          this.finished = true;
        }else{
			this.loading = false;
          // 数据全部加载完成
          if (res.data.data.length < 10) {
            this.finished = true;
          }
          this.goosList = this.goosList.concat(res.data.data);
		//   this.goosList = res.data.data;
		  console.log(this.goosList)
        }
      });
	},
	getRaffle(val){
		 let param ={
			  brand: this.objindex,
			  seller_id: this.shopId,
			   sort: this.sortString,
			   shop_cat_id: "",
			    page_no:this.page_no,
			  page_size:this.page_size,
			  priceSmall: this.lowPrice,
			   keyword: val, 
			   priceBig: this.highPrice
		  }
		this.getRequest(`goods/search/cjGoods`, param).then(res => {
			if (res.data.code == 1) {
          this.goosList = [];
          this.loading = false;
          this.finished = true;
        }else{
		  this.loading = false;
          if (res.data.data.length < 10) {
            this.finished = true;
          }
          this.goosList = this.goosList.concat(res.data.data);
		}
			
		})
	},
	onSearch(val){
		this.page_no = 1;
		 this.goosList = [];
		 if(this.israffle == 1){
			this.getRaffle(val);
		}else{
			this.getList(val);
		}
	},
	// comprehensive(){
	// 	this.page_no = 1;
	// 	this.goosList = [];
	// 	this.getList(1,'');
	// },
	// salesVolume(){
	// 	this.page_no = 1;
	// 	this.goosList = [];
	// 	this.getList(2,'');
	// },
	// Price(){
	// 	this.page_no = 1;
	// 	this.goosList = [];
	// 	this.getList(3,'');
	// },
    togglePermu() {
      if (this.permutation == "vertical") {
        this.permutation = "rect";
      } else {
        this.permutation = "vertical";
      }
	},
	getsxData(){
      this.getRequest(`goods/search/brands`,{page_no:1,page_size:10000000}).then(res => {
        // this.hotList = res.data.data;
        if (res.data.code == 1) {
         this.sxpp = []
        } else {
         this.sxpp = res.data.data
        }
      });
    },

	goCommodityDetails(Ids){
		this.$router.push({
			path:'./goodsDetail',
			query:{
				goods_id : Ids
			}
			}) 
		console.log(Ids)
	},
	showFilters() {
		this.showFilter = true
	}
  }
};
</script>
<style scoped lang='less'>
.goodListBox {
  .goodListHead {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
	position: fixed;
	width: 100%;
	padding: 0 30px;
	top: 0;
	z-index: 998;
    .headLeft {
      img {
        width: 20px;
        height: 36px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
	}
	
    .centerSearch {
      width: 90%;
      height: 110px;
    }
    .headRight {
      img {
        width: 34px;
        height: 30px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 26px;
      }
    }
  }
  /deep/ .Commission {
			img {
				width: 66px;
				height: 28px;
				float: right;
			}
		}
  .listTools {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
	padding: 20px 0;
	position: fixed;
	top: 110px;
	width: 100%;
	z-index: 998;
    div {
      width: 25%;
      text-align: center;
      span {
        font-size: 28px;
        color: #333333;
      }
      img {
        display: inline-block;
        width: 16px;
        height: 20px;
      }
    }
  }
  .goodslistbox{
	  margin-top: 190px;
  }
  .filterContent {
  	padding: 10px 0px;

  	.topIcon {
  		width: 60px;
  		height: 12px;
  		background-color: #B9B9B9;
  		border-radius: 8px;
  		margin: 0 auto;
  	}
  
  	.priceRange {
  		text-align: center;
  		padding: 0 20px;
  		border-bottom: solid 4px #F2F2F2;
  
  		h4 {
  			text-align: left;
  			margin: 25px 0;
  		}
  
  		/deep/ .van-cell {
  			width: 40%;
  			background: rgba(242, 242, 242, 1);
  			border-radius: 30px;
  			padding: 5px;
  			display: inline-block;
  			text-align: center;
  
  			input {
  				text-align: center;
  			}
  		}
  
  		span {
  			display: inline-block;
  			margin-bottom: 30px;
  			margin: 0 20px;
  			height: 80px;
  			vertical-align: middle;
  		}
  	}
  
  	.brand {
  		padding: 20px;
  		background-color: #fff;
  
  		h4 {
  			color: #040404;
  			font-size: 24px;
  			margin-bottom: 26px;
  		}
  
  		.brandList {
        max-height: 400px;
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;
  			span {
  				background: rgba(242, 242, 242, 1);
  				border-radius: 27px;
          min-width: 140px;
          padding: 0 20px;
  				height: 54px;
  				text-align: center;
  				line-height: 54px;
  				margin-right: 14px;
  				margin-bottom: 30px;
  			}
  			span.active {
  				border: solid 2px #F33925;
  				color: #FE5E15;
  			}
  		}
  	}
  	.dayLuckDraw {
  		padding: 20px;
  		background-color: #fff;
  		border-bottom: solid 4px #F2F2F2;
  		h4 {
  			color: #040404;
  			font-size: 24px;
  			margin-bottom: 26px;
  		}
  		.LuckDraw{
  			span {
  				display: inline-block;
  				background: rgba(242, 242, 242, 1);
  				border-radius: 27px;
  				width: 167px;
  				height: 54px;
  				text-align: center;
  				line-height: 54px;
  				margin-right: 14px;
  				margin-bottom: 30px;
  			}
  			span.active {
  				border: solid 2px #F33925;
  				color: #FE5E15;
  			}
  		}
  	}
  	.filterBtn{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      box-sizing: border-box;
  		.resetBtn{
  			width:294px;
  			height:67px;
  			background:rgba(255,255,255,1);
  			border-radius:34px;
  			border:1px solid rgba(148,148,148,1);
  			color: #343434;
  			font-size: 24px;
  			margin-right: 26px;
  		}
  		.saveBtn{
  			width:294px;
  			height:67px;
  			background: linear-gradient(to right,#F2170C,#F24C0B);
  			color: #fff;
  			font-size: 24px;
  			border-radius:34px;
  			
  		}
  	}
  }
}
</style>

